import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import {
  BreadcrumbService,
  BreadcrumbItem,
} from 'src/app/services/breadcrumb/breadcrumb.service';
import {
  DRAFT_TABS,
  DRAFTS_PAGE_URL,
  DraftTab,
  isDraftTab,
} from 'src/app/data/draft-tabs';

@Component({
  selector: 'app-dashboard-drafts',
  templateUrl: './dashboard-drafts.component.html',
  styleUrls: ['./dashboard-drafts.component.scss'],
})
export class DashboardDraftsComponent implements OnInit {
  canView: Record<DraftTab, boolean> = {
    types: true,
    witnesses: true,
    models: true,
    bonds: true,
    variables: true,
  };

  activeTab: DraftTab = 'types';

  constructor(
    private toast: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
  ) {}

  ngOnInit(): void {
    this.setPermissions();
    this.applyTabFromQuery(this.route.snapshot.queryParamMap.get('tab'));
    this.setBreadcrumb();

    this.route.queryParamMap.subscribe((params) => {
      this.applyTabFromQuery(params.get('tab'));
    });

    if (!DRAFT_TABS.some(({ tab }: { tab: DraftTab }) => this.canView[tab])) {
      this.toast.show(
        'error',
        'Aviso',
        'Você não tem permissão para acessar essa página.',
      );
      this.router.navigateByUrl('/app/dashboard');
    }
  }

  setBreadcrumb(): void {
    const breadcrumbs: BreadcrumbItem[] = [
      {
        label: 'Minutas',
        url: DRAFTS_PAGE_URL,
        clickable: false,
      },
    ];
    this.breadcrumbService.setBreadcrumbs(breadcrumbs);
  }

  setPermissions() {
    DRAFT_TABS.forEach(
      ({ tab, permission }: { tab: DraftTab; permission: string }) => {
        this.canView[tab] = this.authService.verifyPermission([permission]);
      },
    );

    this.activeTab =
      DRAFT_TABS.find(({ tab }: { tab: DraftTab }) => this.canView[tab])?.tab ??
      'types';
  }

  onTabChange(tab: DraftTab) {
    this.activeTab = tab;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  shouldShowCard(cardType: DraftTab): boolean {
    return this.activeTab === cardType && this.canView[cardType];
  }

  private applyTabFromQuery(tab: string | null) {
    if (isDraftTab(tab) && this.canView[tab as DraftTab]) {
      this.activeTab = tab;
    }
  }
}
